import { render, staticRenderFns } from "./Sidebar-comp.vue?vue&type=template&id=72b4b7a9&"
import script from "./Sidebar-comp.vue?vue&type=script&lang=js&"
export * from "./Sidebar-comp.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar-comp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VListGroup,VListItemGroup,VListItemTitle,VNavigationDrawer})
